import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const DiscountTagsIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M2 2C2 1.44772 2.44772 1 3 1H7.58579C7.851 1 8.10536 1.10536 8.29289 1.29289L15.2929 8.29289C15.6834 8.68342 15.6834 9.31658 15.2929 9.70711L10.7071 14.2929C10.3166 14.6834 9.68342 14.6834 9.29289 14.2929L2.29289 7.29289C2.10536 7.10536 2 6.851 2 6.58579V2ZM5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6Z",
    fill: color
  }), __jsx("path", {
    d: "M1.29289 7.79289C1.10536 7.60536 1 7.351 1 7.08579V2C0.447715 2 0 2.44772 0 3V7.58579C0 7.851 0.105356 8.10536 0.292892 8.29289L7.29289 15.2929C7.68342 15.6834 8.31658 15.6834 8.70711 15.2929L8.75 15.25L1.29289 7.79289Z",
    fill: color
  }));
};
export default DiscountTagsIcon;